module.exports = {
  context: {
    form: {
      fields: [
        {
          type: 'text',
          isRequired: 'true',
          handle: 'name',
          label: 'Name'
        },
        {
          type: 'email',
          isRequired: 'true',
          handle: 'email',
          label: 'Email address'
        },
        {
          type: 'textarea',
          isRequired: 'true',
          handle: 'message',
          label: 'message'
        }
      ]
    }
  }
}